<template>
    <div>   
          <v-card style="padding-left:20%;padding-right:20% " flat :class="{'mobileStep': $vuetify.breakpoint.xsOnly , 'compact-formTicket': $vuetify.breakpoint.smAndUp, 'xlargeWidth': $vuetify.breakpoint.xl}" v-if="chooseEstate" >
                          <br><br>                          
                                <v-col v-if="!appLoading"
                                   cols="12"
                                    sm="12"
                                 >
                                 <h2 :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" style="text-align:center">Choose Your Area</h2>
                                </v-col>
                                 <v-row v-if="!appLoading">
                                 <v-col v-if="!appLoading"
                                   cols="6"
                                    sm="6"
                                 >
                                     <v-autocomplete
                                                class="pointer"
                                                style="cursor: pointer;"
                                                clearable
                                                v-model="detail.address.estate"
                                                :rules="[v => !!v || 'Estate is required']"
                                                :items="estateList"
                                                :loading="appLoading"
                                                v-on:change="setUnitList($event)"
                                                text
                                                color="primary"
                                                label="Estate*"
                                                item-text="name"
                                                item-value="id"
                                                >
                                                </v-autocomplete>
                                 </v-col>                                
                                  <v-col 
                                   cols="6"
                                    sm="6"
                                  v-if="this.detail.address.estate==null " >   
                                             <v-autocomplete
                                                disabled
                                                class="pointer"
                                                style="cursor: pointer; "
                                                clearable
                                                v-model="locationTemplate"
                                                :items="unitList"
                                                :loading="appLoading"
                                                text
                                                color="primary"
                                                :rules="[v => !!v || 'Address is required']"
                                                label="Find My Address*"
                                                item-text="locationDescription"
                                                item-value="id"
                                                return-object
                                                >
                                                </v-autocomplete>
                                                </v-col>
                                                  <v-col 
                                   cols="6"
                                    sm="6"
                                  v-if="this.detail.address.estate!=null " >   
                                             <v-autocomplete
                                                class="pointer"
                                                style="cursor: pointer; "
                                                clearable
                                                v-model="locationTemplate"
                                                :items="unitList"
                                                :loading="appLoading"
                                                text
                                                color="primary"
                                                :rules="[v => !!v || 'Address is required']"
                                                label="Find My Address*"
                                                item-text="locationDescription"
                                                item-value="id"
                                                return-object
                                                >
                                                </v-autocomplete>
                                                </v-col>
                                      </v-row>
                                   <v-container v-if="appLoading">                                                        
                                  <br ><br><br><br>
                                   </v-container>
                                <v-col v-if="appLoading"
                                style="text-align:center; text-justify:center"
                                   cols="12"
                                    sm="12"
                                 >
                                 <vue-loaders-ball-spin-fade-loader
                                            v-if="appLoading"
                                            :key="appLoading"
                                            color="primary"
                                            scale="1.5"
                                            ></vue-loaders-ball-spin-fade-loader><br><br>
                                 <h2 style="text-align:center;" :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour: $store.state.currentOrg.secondaryColour}" v-if="appLoading&&loadingText!==null">{{loadingText}}</h2>
                                 </v-col>
                             <v-col v-if="!appLoading"
                                    cols="12"
                                    sm="12"
                                   >
                                 <h2 :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}"  style="text-align:center;">Contact Information</h2>
                                </v-col>
                                   <v-row v-if="!appLoading">
                                    <v-col  cols="4" sm="4" >
                                        <v-select  v-model="detail.primaryContact.title"
                                                  clearable
                                                  :items="titles"
                                                  :rules="titleRules"
                                                  label="Title*"
                                                  class="input-flex-min-space">
                                        </v-select>
                                     </v-col>
                                   
                                     <v-col  cols="4" sm="4" >
                                        <v-text-field  v-model="detail.primaryContact.firstName"
                                                      label="First Name* "
                                                      :rules="nameRules"
                                                      class="input-flex-min-space">
                                        </v-text-field>
                                    </v-col>
                                   
                                      <v-col  cols="4" sm="4" >
                                        <v-text-field  v-model="detail.primaryContact.lastName"
                                                      label="Last Name*"
                                                      :rules="surnameRules"
                                                      class="input-flex-min-space">
                                        </v-text-field>
                                    </v-col>
                                    </v-row>
                                    <v-row v-if="!appLoading">
                                      <v-col cols="4" sm="4"  >
                                        <v-text-field  class="input-flex-min-space"
                                                      v-model="detail.primaryContact.contactNumber"
                                                      :rules="contactNumberRules"
                                                      label="Contact Number*">
                                        </v-text-field>
                                     </v-col>
                                      <v-col cols="4" sm="4"  >
                                        <v-text-field  class="input-flex-min-space"
                                                      v-model="detail.primaryContact.emailAddress"
                                                      :rules="emailRules"
                                                      label="Email Address*">
                                        </v-text-field>
                                     </v-col>
                                    </v-row>                                           
                           
                                  <v-col v-if="!appLoading"
                                    cols="12"
                                    sm="12"
                                   >
                                 <h2 :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" style="text-align:center">Ticket Information</h2>
                                </v-col>

                                <v-row v-if="!appLoading">
                                   <v-col cols="6" sm="6"  >
                                     <v-autocomplete @input="filterItem()" :items="ticketCategories" label="Select a Ticket Category" item-text="name" item-value="id" v-model="ticketItem.ticketCategoryId"></v-autocomplete>
                                    </v-col>
                                      <v-col cols="6" sm="6"  >
                                        <v-autocomplete v-if="ticketItem.ticketCategoryId" xs6 :items="filteredCategoryItems" label="Select a Subcategory" item-text="name" item-value="id" v-model="ticketItem.ticketCategoryItemId"></v-autocomplete>
                                        <v-autocomplete v-else disabled :items="ticketCategories" label="Select a Subcategory" item-text="name" item-value="id"></v-autocomplete>
                                     </v-col>
                                      
                                    </v-row>
                                     <v-row v-if="!appLoading">
                                    <v-col cols="12" sm="12"  >
                                       <v-textarea label="Please provide more details regarding your issue..." outline auto-grow v-model="ticketItem.description"></v-textarea>
                                        </v-col>
                                        </v-row>
                                <v-col v-if="!appLoading" style="text-align:center;" cols="12" sm="12"  >
                                     <v-btn v-if="validateArea()==true && validateContact()==true && validateTicket()==true"
                                      @click="submit()" rounded color="primary" >
                                        <span style="color:white">Submit</span>
                                      </v-btn>
                                      <v-btn disabled v-else @click="submit()" rounded color="primary" >
                                        <span style="color:white">Submit</span>
                                      </v-btn>
                                 </v-col>                                  
            </v-card>

              <!-- Complete modal -->
                        <v-card flat v-if="chooseComplete">                      
                         
                            <v-container style="text-align:center;" >     
                               <v-icon size="150" color="primary">mdi-checkbox-marked-circle</v-icon>
                            </v-container>    
                            <v-container style="text-align:center;">                       
                               <h2 color="primary">Submission Successful</h2>
                               <h3 color="primary">Thank you for submitting your issue.</h3>
                            </v-container>
                           <v-container style="text-align:center;">
                                      <v-btn  medium color="primary"
                                        rounded @click=" clearFields(); chooseEstate=true; chooseComplete=false " >                                       
                                        OK
                                      </v-btn>
                             </v-container>                             
                            </v-card>
    </div>
</template>
<script>
import Api from '@/services/Api.js'

export default {
  
    data(){
        return {
           chooseComplete:false,
           locationId:null, 
           locationNetworkId:null, 
           createdById:null,
           orgId:null,
           contactInfo:[],
           ticketCategories:[],
           filteredCategoryItems: [],
           ticketItem: {},
           titles: ["Mr", "Mrs", "Miss", "Dr", "Prof", "Sir", "Madam", "Other"],
           key: 0,
           chooseEstate:true,
           appLoading: false,
           estateList: [],
           unitList: [],
           unusedUnitList: [],
           locationTemplate: null,
           max:1,
           estateArr:['1'],
           detail: {
                    primaryContact: {},
                    secondaryContact: {},
                    address: {
                        unitNumber: null,
                        fullUnitDetails: null
                    }
           },          
      nameRules: [
        v => !!v || 'Name is required'
      ],
      surnameRules: [
        v => !!v || 'Last Name is required'
      ],
      contactNumberRules: [
        v => !!v || 'Contact Number is required',
        v => v && v.length > 9 || 'Contact Number should be 10 digits'
      ],
     emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      titleRules:[
         v => !!v || 'Title is required',
      ],                   
          
        }
    },
    watch: {
       locationTemplate(value){
                if(typeof value!=='undefined'&&value!==null){
 
                    this.selectUnit(value)
                }
            },
            'detail.address.estate':{
                      immediate: true,
                     handler(value) {
                         this.estateArr.push(value)
                         if(this.estateArr[0] != value){
                         this.max=1
                         }
                        this.estateArr.shift()
            }
            },  
    },
    created(){
       this.fetchEstates();
       this.fetchCategories();        
    },
    methods: {
      clearFields(){
           this.ticketItem={},
           this.locationId=null, 
           this.locationNetworkId=null, 
           this.createdById=null,
           this.detail.primaryContact= {},
           this.detail.address.unitNumber=null,
           this.detail.address.fullUnitDetails=null,
           this.detail.address.estate=null,
           this.locationTemplate=null
 
      },
        fetchCategories(){
            Api()
             .get('/ticketCategory/getCategoryByEndCustomer')
             .then(response=>{
                this.ticketCategories = response.data
                this.orgId = response.data[0].organisationId
        })
        },
        filterItem(){
            Api()
             .get('/ticketCategoryItem/getByCategoryId/' + this.ticketItem.ticketCategoryId)
             .then(response=>{
                this.filteredCategoryItems = response.data
        })
        },
        fetchEstates() {
                this.appLoading=true
                this.loadingText =" \n\nFetching Available Networks..."
                Api()
                    .get('/ftthApplication/activelocationnetworks')
                    .then(response => {
                        let estateList = response.data
                        this.estateList = estateList.filter(function (el) {
                        return el.networkStatus!=='Planned'
                        })
                        this.appLoading=false
                    });
            },
      setUnitList(e) {
                this.detail.address.unitNumber = null
               for (let k=0; k<this.estateList.length; k++) {
                    if (this.estateList[k].id == e) {
                        this.detail.address.suburb = this.estateList[k].suburb
                        this.detail.address.streetName = this.estateList[k].streetName
                        this.detail.address.city = this.estateList[k].city
                        this.unitList = this.estateList[k].locations
                        this.unusedUnitList = this.estateList[k].locations
                        this.detail.selectedNetwork = this.estateList[k]
                    }
                } 
            },
              selectUnit(obj) {
                this.selectUnitModal = false 
                this.detail.address.unitNumber = obj.locationDescription;
                this.detail.address.fullUnitDetails = obj;
                this.locationId = this.detail.address.fullUnitDetails.id
                this.locationNetworkId= this.detail.address.fullUnitDetails.locationNetworkId
                this.key += 1
            },
                 validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
        validateContact(){            
           if((this.detail.primaryContact.title != null && this.detail.primaryContact.title != '') && (this.detail.primaryContact.firstName != null && this.detail.primaryContact.firstName != '') && (this.detail.primaryContact.lastName != null && this.detail.primaryContact.lastName != '')
                              && (this.detail.primaryContact.contactNumber != null && this.detail.primaryContact.contactNumber != '' && this.detail.primaryContact.contactNumber.length >= 10) && (this.detail.primaryContact.emailAddress != null && this.detail.primaryContact.emailAddress != '' && this.validEmail(this.detail.primaryContact.emailAddress)) )
                              {
                                      return true
                              }
        },
        validateArea(){
            if( (this.locationId!= null && this.locationId!= '') && (this.locationNetworkId!= null && this.locationNetworkId!= ''))
                              {
                                      return true
                              }
        }, 
        validateTicket(){
            if((this.ticketItem.ticketCategoryId!=null && this.ticketItem.ticketCategoryId!='') && (this.ticketItem.ticketCategoryItemId != null && this.ticketItem.ticketCategoryItemId != '') && (this.ticketItem.description != null && this.ticketItem.description != '')){
                return true
            }
        },   
        submit(){
            Api().get('/contacts/byEmail/'+ this.detail.primaryContact.emailAddress)
            .then(response=>{                     
            if(typeof(response.data)=='object'){
                   Api().post("/ticket", {                     
                        createdById: response.data.id,
                        currentStatus: 'Pending',
                        importance: 'Normal',
                        isComplete: false,
                        description: this.ticketItem.description,
                        dueDate: null,
                        dueTime: null,
                        isActive: true,
                        isDeleted: false,
                        createdAt: this.ticketItem.createdAt,
                        updatedAt: this.ticketItem.updatedAt,
                        ticketCategoryItemId: this.ticketItem.ticketCategoryItemId,
                        organisationId: this.orgId,
                        locationId: this.locationId,
                        locationNetworkId: this.locationNetworkId
        }).then(response=>{
          this.chooseComplete=true
          this.chooseEstate=false
        })
            }else if(typeof(response.data)=='string'){           
        Api().post("/contacts", {
          name: this.detail.primaryContact.firstName,
          surname: this.detail.primaryContact.lastName,
          mobileNumber: this.detail.primaryContact.contactNumber,
          emailAddress: this.detail.primaryContact.emailAddress,
          permissions: 'End Client',
          organisationId: this.orgId,
          isActive: true
        }).then(response => {
            let id = response.data.id
             Api().post("/ticket", {
                        currentStatus: 'Pending',
                        importance: 'Normal',
                        isComplete: false,
                        description: this.ticketItem.description,
                        dueDate: null,
                        dueTime: null,
                        isActive: true,
                        isDeleted: false,
                        createdAt: this.ticketItem.createdAt,
                        updatedAt: this.ticketItem.updatedAt,
                        ticketCategoryItemId: this.ticketItem.ticketCategoryItemId,
                        createdById: id,
                        organisationId: this.orgId,
                        locationId: this.locationId,
                        locationNetworkId: this.locationNetworkId
                    }).then(response=>{
                      this.chooseComplete=true
                       this.chooseEstate=false
                })
               })
            }
            })            
        },         
    }    
}
</script>
<style>
.compact-formTicket{
    transform: scale(0.8);
    transform-origin: top;
}
</style>